import React from 'react';
import FigmaBadge from '../Elements/FigmaBadge';
import FieldTypesEnum from '../Enums/FieldTypesEnum';

export default class FraudHitEvaluatorMatchItem {
  constructor(item) {
    this.initialize(item);
  }

  async initialize(item) {
    this.FraudHitEvaluatorMatchId = item.fraudHitEvaluatorMatchId;
    this.MatchesEmail = item.matchesEmail;
    this.MatchesAlipay = item.matchesAlipay;
    this.MatchesPaypal = item.matchesPaypal;
    this.MatchesPaynow = item.matchesPaynow;
    this.MatchesPhone1 = item.matchesPhone1;
    this.MatchesPhone2 = item.matchesPhone2;
    this.MatchesIban = item.matchesIban;
    this.MatchesBankAccount = item.matchesBankAccount;
    this.MatchesWise = item.matchesWise;
    this.QueryType = item.queryType;
    this.MatchingRecord = item.matchingRecord;
    this.DetectedDate = item.detectedDate;
  }
  static NameOfTheIdField() {
    return 'Id';
  }

  static nameOfTheItemDetailList() {
    return 'Fraud Hit Evaluator Match';
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return '';
  }

  static DateFields = ['DetectedDate'];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Match ID',
        orderById: 'FraudHitEvaluatorMatchId',
        data: 'FraudHitEvaluatorMatchId',
        type: FieldTypesEnum.PureDataField,
        minWidth: 70,
      },
      {
        label: 'Query Type',
        orderById: 'QueryType',
        data: 'QueryType',
        type: FieldTypesEnum.PureDataField,
        minWidth: 70,
      },
      {
        label: 'Matching Record',
        orderById: 'MatchingRecord',
        data: 'MatchingRecord',
        type: FieldTypesEnum.PureDataField,
        minWidth: 70,
      },
      {
        label: 'Email',
        orderById: 'MatchesEmail',
        data: (item) => FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesEmail, item, 'Email'),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'Alipay',
        orderById: 'MatchesAlipay',
        data: (item) => FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesAlipay, item, 'Alipay'),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'Paypal',
        orderById: 'MatchesPaypal',
        data: (item) => FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesPaypal, item, 'Paypal'),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'PayNow',
        orderById: 'MatchesPaynow',
        data: (item) => FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesPaynow, item, 'PayNow'),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'Wise',
        orderById: 'MatchesWise',
        data: (item) => FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesWise, item, 'Wise'),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      // {
      //   label: 'Phone 1',
      //   orderById: 'MatchesPhone1',
      //   data: (item) => FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesPhone1, item, 'Phone 1'),
      //   type: FieldTypesEnum.PureDataField,
      //   minWidth: 20,
      // },
      // {
      //   label: 'Phone 2',
      //   orderById: 'MatchesPhone2',
      //   data: (item) => FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesPhone2, item, 'Phone 2'),
      //   type: FieldTypesEnum.PureDataField,
      //   minWidth: 20,
      // },
      {
        label: 'IBAN',
        orderById: 'MatchesIban',
        data: (item) => FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesIban, item, 'IBAN'),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'Bank Account',
        orderById: 'MatchesBankAccount',
        data: (item) =>
          FraudHitEvaluatorMatchItem.getBadgeContent(item.MatchesBankAccount, item, 'Bank Account'),
        type: FieldTypesEnum.PureDataField,
        minWidth: 20,
      },
      {
        label: 'Detected Date',
        orderById: 'DetectedDate',
        data: 'DetectedDate',
        type: FieldTypesEnum.PureDataField,
        minWidth: 70,
      },
    ];
  }

  static setInfo(item) {
    //This is a placeholder, don't remove it!
  }

  static getBadgeContent(currentField, item, tooltip) {
    return (
      <div
        onClick={() => FraudHitEvaluatorMatchItem.setInfo(item)}
        className='pointer'
      >
        {
          <FigmaBadge
            Active={!currentField}
            ActiveText='No'
            InactiveText='Yes'
            width={50}
            tooltip={`Base shopper's ${item.QueryType} ${currentField ? 'same as' : 'NOT the same as'} second shopper's ${tooltip}`}
          />
        }
      </div>
    );
  }

  static FieldsToShowInListTable = [
    {
      tabName: 'Info',
      tabLabel: 'Info',
      icon: 'fa-solid fa-info',
      data: [{ label: 'Match ID', name: 'FraudHitEvaluatorMatchId' }],
    },
  ];
}
